import React, { useState } from 'react';
import { getContrastingColor } from '../../helpers';
// import Bin from '../../assets/bin.svg';
import {ReactComponent as Bin} from '../../assets/bin.svg';
import {ReactComponent as Edit} from '../../assets/edit.svg';
import Cancel from '../../assets/cross.svg';
import Accept from '../../assets/accept.svg';
import { useDispatch } from 'react-redux';
import { deleteOfficeExpense, editOfficeExpense } from '../../redux/officeSlice';
import { Input } from '../../components/Input';
import { Select } from '../../components/Select';



const ExpenseItem = ({
    createdAt,
    amount,
    UTC,
    comment,
    category,
    _id,
    categories,
}) => {
    const dispatch = useDispatch();
    const createdDate = new Date(createdAt).toLocaleString('ru').split(', ').join(' в ');
    const [isEdit, setEdit] = useState(false);

    const [expAmount, setAmount] = useState(amount);
    const [expComment, setComment] = useState(comment);
    const [expCategory, setCategory] = useState(category._id)

    const deleteHandler = () => {
        if (window.confirm('Удалить расход?')) {
            dispatch(deleteOfficeExpense(_id));
        }
    };
    const cancelHandler = () => {
        setEdit(false);
        setAmount(amount);
        setComment(comment);
        setCategory(category._id);
    }

    const saveChangesHandler = () => {
        const obj = {};
        if (isNaN(+expAmount) || !expAmount || +expAmount <= 0) return;
        if (expAmount !== amount) {
            obj.amount = +expAmount;
        }
        if (expComment !== comment) {
            obj.comment = expComment;
        }
        if (expCategory !== category._id) {
            obj.category = expCategory;
        }
        if (Object.keys(obj).length) {
            dispatch(editOfficeExpense({...obj, _id}));
        }
        setEdit(false);
    }

    const textColor = getContrastingColor(category.color);

    return (
        <div className={`expense__item ${isEdit ? 'edit' : ''}`}>
            <div title={createdDate}>{createdDate}</div>
            {!isEdit ? (
                <>
                    <div className="expense__item-category">
                        {comment} <span style={{ backgroundColor: category.color, color: textColor}}>{category.name}</span>
                    </div>
                    <div>{amount}</div>
                </>
            ) : (
                <>
                    <Input placeholder='Коммент' value={expComment} changeHandler={(e) => setComment(e.target.value)} />
                    <Select enums={categories} value={expCategory} changeHandler={(e) => setCategory(e.target.value)} />
                    <Input placeholder='Сумма' value={expAmount} changeHandler={(e) => setAmount(e.target.value)} />
                </>
            )}

            {isEdit ? (
                <>
                    <div className="expense__item-accept expense__item-btn">
                        <Accept width={24} height={24} className={`button`} onClick={saveChangesHandler} />
                    </div>
                    <div className="expense__item-cancel expense__item-btn">
                        <Cancel
                            width={24}
                            height={24}
                            className={`button`}
                            onClick={cancelHandler}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="expense__item-edit expense__item-btn">
                        <Edit
                            width={24}
                            height={24}
                            className={`button`}
                            onClick={() => setEdit(true)}
                        />
                    </div>
                    <div className="expense__item-delete expense__item-btn">
                        <Bin width={24} height={24} className={`button`} onClick={deleteHandler} />
                    </div>
                </>
            )}
        </div>
    );
};

export const Expenses = ({ list, error, categories }) => {
    const titles = ['Дата', 'Расход', 'Сумма'];

    const sortedList = [...list].sort((a, b) => b.details.created.at - a.details.created.at);

    return (
        <div className="office__expenses expenses">
            <div className="expenses__titles-container">
                <div className="expenses__titles">
                    {titles.map((title, index) => (
                        <div key={index}>{title}</div>
                    ))}
                </div>
            </div>
            <div className="expenses__list" style={{ height: list.length ? 'auto' : '100%' }}>
                {list.length ? (
                    sortedList.map((e) => (
                        <ExpenseItem
                            categories={categories}
                            _id={e._id}
                            UTC={e.city.UTC}
                            createdAt={e.details.created.at}
                            comment={e.comment}
                            amount={e.amount}
                            category={e.category}
                            key={e._id}
                        />
                    ))
                ) : (
                    <div className="no-items">{error || 'Нет Расходов'}</div>
                )}
            </div>
        </div>
    );
};
